import React, { Component } from 'react';
import './starRating.scss';

interface IStarRatingProps {
    rate: number;
    score: number;
}

export default class StarRating extends Component<IStarRatingProps, {}> {
    public render() {
        return (
            <div className="star-rating">
                <div className="star-shape">
                    {[...Array(5)]
                        .join(',')
                        .split(',')
                        .map((_item, index) => {
                            return this.renderStar(index);
                        })}
                </div>
                <div className="star-rate">{this.props.score}</div>
            </div>
        );
    }

    private renderStar(index: number) {
        index = index + 1;
        const rate = this.props.rate;
        let width = 100;

        // 小于比值的星星全部黄色，大于比值的星星为白色，临界点的星星根据数值来设置黄色的范围
        const diff = index - rate;
        if (diff > 0) {
            if (diff >= 1) {
                width = 0;
            } else {
                width = ((1 - diff) / 1) * 100;
            }
        }
        const starStyle = {
            width: `${width}%`,
        };

        return (
            <div className="star-rank-unit" key={index}>
                <div className="stars-wrap" style={starStyle} />
                <div className="star-frames-wrap" />
            </div>
        );
    }
}
